import React, { useState } from 'react';
import { Dialog } from 'components';
import DateField from 'components/DateField';
import { Grid, TextField } from '@material-ui/core';
import { addHoliday } from 'store/firebase';
import { useAlert, useReduxDispatch } from 'store/hooks';
import { fetchHolidays } from 'store/holiday';

const AddHolidayDialog = ({ open, close }) => {
  const [draft, setDraft] = useState({});
  const { alertError } = useAlert();
  const getHolidayList = useReduxDispatch(fetchHolidays);

  const onChange = (key, value) => setDraft({ ...draft, [key]: value });

  const handleAddHoliday = () => {
    addHoliday(draft).then(() => {
      getHolidayList();
      setDraft({});
    }).catch((err) => {
      alertError(err?.message || err);
    });
    close(false);
  }

  return (
    <Dialog
      title='Tambah Hari Libur'
      fullWidth
      open={open}
      onClose={() => {
        close(false);
        setDraft({});
      }}
      action={{
        label: 'Tambahkan',
        onClick: () => {
          handleAddHoliday();
        }
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6}>
          <DateField
            dateOnly
            label="Tanggal Mulai"
            value={ draft?.startDate}
            onChange={(value) =>
              onChange('startDate', value)
            }
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <DateField
            dateOnly
            minDate={draft.startDate}
            label="Tanggal Akhir"
            value={ draft?.endDate}
            onChange={(value) =>
              onChange('endDate', value)
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            label='Keterangan'
            InputLabelProps={{
              shrink: true
            }}
            value={draft.title}
            style={{
              marginBottom: '16px'
            }}
            onChange={(e) =>
              onChange('title', e.target.value)
            }
          />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default AddHolidayDialog
